import type { Template } from "@/types";

export const LA_07_H6_V1: Template[] = [
    {
        id: "la-07-h6v1-01",
        name: "LA 01 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 66, y: 76, width: 280, height: 186, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 269, width: 280, height: 186, rotation: 0, imageRotation: 0 },
            { id: "3", x: 354, y: 76, width: 258, height: 379, rotation: 0, imageRotation: 0 },
            { id: "4", x: 737, y: 76, width: 275, height: 186, rotation: 0, imageRotation: 0 },
            { id: "5", x: 737, y: 269, width: 275, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1020, y: 76, width: 274, height: 186, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1020, y: 269, width: 274, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-02",
        name: "LA 02 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 103, y: 44, width: 470, height: 294, rotation: 0, imageRotation: 0 },
            { id: "2", x: 103, y: 346, width: 231, height: 141, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 346, width: 231, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 759, y: 44, width: 200, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 759, y: 195, width: 200, height: 143, rotation: 0, imageRotation: 0 },
            { id: "6", x: 759, y: 346, width: 200, height: 142, rotation: 0, imageRotation: 0 },
            { id: "7", x: 967, y: 44, width: 303, height: 445, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-03",
        name: "LA 03 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 95, y: 57, width: 487, height: 295, rotation: 0, imageRotation: 0 },
            { id: "2", x: 95, y: 360, width: 157, height: 113, rotation: 0, imageRotation: 0 },
            { id: "3", x: 260, y: 360, width: 157, height: 113, rotation: 0, imageRotation: 0 },
            { id: "4", x: 425, y: 360, width: 157, height: 113, rotation: 0, imageRotation: 0 },
            { id: "5", x: 815, y: 57, width: 376, height: 247, rotation: 0, imageRotation: 0 },
            { id: "6", x: 815, y: 312, width: 257, height: 162, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1080, y: 312, width: 111, height: 162, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-04",
        name: "LA 04 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 118, y: 51, width: 216, height: 138, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 51, width: 216, height: 138, rotation: 0, imageRotation: 0 },
            { id: "3", x: 118, y: 197, width: 216, height: 138, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 197, width: 216, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 118, y: 344, width: 216, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 342, y: 344, width: 216, height: 138, rotation: 0, imageRotation: 0 },
            { id: "7", x: 857, y: 51, width: 314, height: 431, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-05",
        name: "LA 05 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 178, y: 39, width: 320, height: 451, rotation: 0, imageRotation: 0 },
            { id: "2", x: 762, y: 39, width: 329, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 928, y: 269, width: 330, height: 221, rotation: 0, imageRotation: 0 },
            { id: "4", x: 762, y: 269, width: 158, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 762, y: 384, width: 158, height: 106, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1099, y: 39, width: 158, height: 107, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1099, y: 154, width: 158, height: 107, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-06",
        name: "LA 06 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 79, y: 52, width: 517, height: 314, rotation: 0, imageRotation: 0 },
            { id: "2", x: 79, y: 374, width: 168, height: 107, rotation: 0, imageRotation: 0 },
            { id: "3", x: 255, y: 374, width: 167, height: 107, rotation: 0, imageRotation: 0 },
            { id: "4", x: 430, y: 374, width: 167, height: 107, rotation: 0, imageRotation: 0 },
            { id: "5", x: 742, y: 52, width: 258, height: 430, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1008, y: 52, width: 278, height: 211, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1008, y: 271, width: 278, height: 210, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-07",
        name: "LA 07 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 74, y: 39, width: 292, height: 452, rotation: 0, imageRotation: 0 },
            { id: "2", x: 374, y: 39, width: 217, height: 146, rotation: 0, imageRotation: 0 },
            { id: "3", x: 374, y: 193, width: 217, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 374, y: 346, width: 217, height: 145, rotation: 0, imageRotation: 0 },
            { id: "5", x: 768, y: 39, width: 490, height: 300, rotation: 0, imageRotation: 0 },
            { id: "6", x: 768, y: 347, width: 241, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1017, y: 347, width: 241, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-08",
        name: "LA 08 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 74, y: 39, width: 217, height: 146, rotation: 0, imageRotation: 0 },
            { id: "2", x: 74, y: 193, width: 217, height: 145, rotation: 0, imageRotation: 0 },
            { id: "3", x: 74, y: 346, width: 217, height: 145, rotation: 0, imageRotation: 0 },
            { id: "4", x: 299, y: 39, width: 292, height: 452, rotation: 0, imageRotation: 0 },
            { id: "5", x: 887, y: 40, width: 254, height: 146, rotation: 0, imageRotation: 0 },
            { id: "6", x: 887, y: 194, width: 254, height: 145, rotation: 0, imageRotation: 0 },
            { id: "7", x: 887, y: 347, width: 254, height: 145, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-09",
        name: "LA 09 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 58, y: 38, width: 304, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 269, width: 304, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 370, y: 38, width: 303, height: 223, rotation: 0, imageRotation: 0 },
            { id: "4", x: 370, y: 269, width: 303, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 38, width: 302, height: 452, rotation: 0, imageRotation: 0 },
            { id: "6", x: 991, y: 38, width: 303, height: 223, rotation: 0, imageRotation: 0 },
            { id: "7", x: 991, y: 269, width: 303, height: 222, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h6v1-10",
        name: "LA 10 - H6V1",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h6_v1_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 58, y: 38, width: 304, height: 223, rotation: 0, imageRotation: 0 },
            { id: "2", x: 58, y: 269, width: 304, height: 222, rotation: 0, imageRotation: 0 },
            { id: "3", x: 370, y: 38, width: 303, height: 223, rotation: 0, imageRotation: 0 },
            { id: "4", x: 370, y: 269, width: 303, height: 222, rotation: 0, imageRotation: 0 },
            { id: "5", x: 681, y: 38, width: 303, height: 223, rotation: 0, imageRotation: 0 },
            { id: "6", x: 681, y: 269, width: 303, height: 222, rotation: 0, imageRotation: 0 },
            { id: "7", x: 992, y: 38, width: 302, height: 452, rotation: 0, imageRotation: 0 }
        ],
    }
];